import { render, staticRenderFns } from "./OriginalEdit.vue?vue&type=template&id=75cb5742&scoped=true&"
import script from "./OriginalEdit.vue?vue&type=script&lang=js&"
export * from "./OriginalEdit.vue?vue&type=script&lang=js&"
import style0 from "./OriginalEdit.vue?vue&type=style&index=0&id=75cb5742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cb5742",
  null
  
)

export default component.exports